module.exports = __webpack_public_path__ + "img/icon-persons.351cb59e.svg";